import { jsx as _jsx } from "react/jsx-runtime";
import { Heading } from '@chakra-ui/react';
export var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Heading, {
    color: "text.primary",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    children: children
  });
};